import { useRouteError, useNavigate } from 'react-router-dom';
import { useEffect } from "react"
import { useSelector } from "react-redux";
import Cookies from 'js-cookie';

function ErrorBoundary() {
  const error: any = useRouteError();
  const navigate = useNavigate();
  const currentmenu = useSelector((state: any) => state.menu.currentmenu);
  const menu = useSelector((state: any) => state.menu.menu);

  useEffect(() => {
    // 如果是 404 错误或路由匹配错误，直接跳转到第一个可用路由
    const is404Error = error?.status === 404 || error?.statusText === 'Not Found';
    const isRouteMatchError = error?.message?.includes('No route matches URL') ||
      error?.message?.includes('route matches');

    if (is404Error || isRouteMatchError) {
      // 检查是否有 token
      const token = Cookies.get('token') || localStorage.getItem('token');

      if (!token) {
        // 没有 token 时跳转到登录页
        navigate('/login', { replace: true });
        return;
      }

      // 有 token 时，获取第一个可用路由
      if (!menu || menu.length === 0 || !currentmenu || currentmenu.length === 0) {
        // 菜单未加载，跳转到首页让 DefaultTbNavigate 处理
        navigate('/', { replace: true });
        return;
      }

      // 过滤掉 '/' 和 '/login' 路由，获取第一个可用路由
      let routerList = currentmenu
        .map((val: any) => {
          if (val && val.path !== '/' && val.path !== '/login') {
            return val;
          }
          return null;
        })
        .filter((val: any) => val);

      if (routerList.length > 0 && routerList[0].children && routerList[0].children.length > 0) {
        const firstRoute = routerList[0];
        const firstChild = firstRoute.children[0];

        if (firstChild && firstChild.path) {
          const firstPath = `${firstRoute.path}/${firstChild.path}`;
          console.log('404错误，跳转到第一个可用路由:', firstPath);
          navigate(firstPath, { replace: true });
          return;
        }
      }

      // 如果没有可用路由，跳转到首页
      navigate('/', { replace: true });
    }
  }, [error, navigate, currentmenu, menu]);

  return (
    <div>
      <h1>页面不存在</h1>
      <p>正在跳转到首页...</p>
    </div>
  );
}
export default ErrorBoundary

